import React, { useState, useContext } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ShopContext } from '../context/shopcontext';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const { backendUrl } = useContext(ShopContext);
  const { token } = useParams();
  const navigate = useNavigate();

  const onSubmitHandler = async (e) => {
    e.preventDefault();

    if (password.trim().length < 8) {
      toast.error('Password must be at least 8 characters long');
      return;
    }

    if (password !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    try {
      const response = await axios.post(`${backendUrl}/api/user/reset-password/${token}`, {
        password: password.trim(),
      });

      if (response.data.success) {
        toast.success('Password reset successful. Please login.');
        navigate('/login');
      } else {
        toast.error(response.data.message || 'Something went wrong');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Something went wrong');
    }
  };

  return (
    <form
      onSubmit={onSubmitHandler}
      className="flex flex-col items-center w-[90%] sm:max-w-96 m-auto mt-32 gap-4"
      style={{
        color: '#65000B',
        borderRadius: '10px',
        padding: '20px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      }}
    >
      <h2 className="text-xl mb-4 text-[#D3756B]">Reset Password</h2>

      <input
        type="password"
        placeholder="New Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
        autoComplete="new-password"
        className="w-full px-3 py-2 border-2 text-[#65000B] border-[#D3756B] focus:border-[#F0997D] focus:outline-none"
      />

      <input
        type="password"
        placeholder="Confirm New Password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        required
        autoComplete="new-password"
        className="w-full px-3 py-2 border-2 text-[#65000B] border-[#D3756B] focus:border-[#F0997D] focus:outline-none"
      />

      {password && confirmPassword && password !== confirmPassword && (
        <p className="text-sm text-red-500 w-full text-left">Passwords do not match</p>
      )}

      <button
        type="submit"
        disabled={
          password.trim() === '' || confirmPassword.trim() === '' || password !== confirmPassword
        }
        className={`w-full bg-gradient-to-r from-[#dcb7a2] to-[#D3756B] shadow-md rounded-md text-white px-8 py-2 mt-4 transition-all duration-200 ${
          password === confirmPassword && password !== ''
            ? 'hover:shadow-lg cursor-pointer'
            : 'opacity-70 cursor-not-allowed'
        }`}
      >
        Reset Password
      </button>
    </form>
  );
};

export default ResetPassword;
